export const AccentColors = Object.freeze({
    IndicatorRed: '#f44336',
    PositiveGreen: '#4caf50',
    ProgressiveYellow: '#fbc02d',
    ActionBlue: '#2196f3',
    UnknownGray: '#888888',
})